import { Button, Link } from "@endya-conformite/ui-kit";
import ArrowRight from "@endya-conformite/ui-kit/src/assets/icons/arrow-right.svg?react";
import styles from "./CmsHeader.module.scss";

type CmsHeaderProps = {
  title: string;
  to: string;
  showVoirTout?: boolean;
};

export function CmsHeader({ title, to, showVoirTout }: CmsHeaderProps) {
  return (
    <div className={styles.header}>
      <hr className={styles.delimiter} />
      <div className={styles.row}>
        <h2>{title}</h2>

        {showVoirTout && (
          <Link to={to}>
            <Button variant="text" icon={<ArrowRight />}>
              Voir tout
            </Button>
          </Link>
        )}
      </div>
    </div>
  );
}
